const AccessTokenKey = 'ACCESS_TOKEN'
const RefreshTokenKey = 'REFRESH_TOKEN'
const SystemInfo = 'SYSTEM_INFO'
const TenantIdKey = 'TENANT_ID'
let activeTenantId: string | undefined

export const getStoredTenantId = () => {
    if (activeTenantId === undefined) activeTenantId = String(uni.getStorageSync(TenantIdKey) || '')
    return activeTenantId
}

const scopedTokenKey = (key: string) => key + ':' + (getStoredTenantId() || 'single')
export const getTokenStorageKeys = () => [scopedTokenKey(AccessTokenKey), scopedTokenKey(RefreshTokenKey)]

function readToken(key: string) {
    const scopedKey = scopedTokenKey(key)
    const token = uni.getStorageSync(scopedKey)
    if (token) return token
    // Migrate legacy credentials only into their recorded enterprise.
    if (String(uni.getStorageSync(TenantIdKey) || '') !== getStoredTenantId()) return ''
    const legacy = uni.getStorageSync(key)
    if (legacy) {
        uni.setStorageSync(scopedKey, legacy)
        uni.removeStorageSync(key)
    }
    return legacy
}

// ========== Token 相关 ==========

export function getAccessToken() {
    return readToken(AccessTokenKey)
}

export function getRefreshToken() {
    return readToken(RefreshTokenKey)
}

export function setToken(token) {
    uni.setStorageSync(scopedTokenKey(AccessTokenKey), token.accessToken)
    uni.setStorageSync(scopedTokenKey(RefreshTokenKey), token.refreshToken)
}

// ========== 设备信息 ==========

export function setSystemInfo(data) {
    uni.setStorageSync(SystemInfo, data)
}

export function getSystemInfo() {
    return uni.getStorageSync(SystemInfo)
}

// ========== 租户相关 ==========

export const getTenantId = () => {
    return getStoredTenantId() || '1'
}

export const setTenantId = (username) => {
    // Finish legacy migration before changing the recorded enterprise.
    getAccessToken()
    getRefreshToken()
    if (String(uni.getStorageSync(TenantIdKey) || '') === getStoredTenantId()) {
        uni.removeStorageSync(AccessTokenKey)
        uni.removeStorageSync(RefreshTokenKey)
    }
    activeTenantId = String(username)
    uni.setStorageSync(TenantIdKey, username)
}

export function removeToken() {
    uni.removeStorageSync(scopedTokenKey(AccessTokenKey))
    uni.removeStorageSync(scopedTokenKey(RefreshTokenKey))
    if (String(uni.getStorageSync(TenantIdKey) || '') === getStoredTenantId()) {
        uni.removeStorageSync(AccessTokenKey)
        uni.removeStorageSync(RefreshTokenKey)
    }
    // uni.removeStorageSync(TenantIdKey)
}


export function isLogin() {
    return !!getAccessToken()
}
